<ng-container *transloco="let t; read: 'basket'">
  @if (vm$ | async; as vm) {
    <form [formGroup]="form">
      <kendo-formfield>
        <kendo-dropdownlist
          #company
          [data]="vm.companies"
          [defaultItem]="defaultItem"
          [kendoDropDownFilter]="filterSettings"
          [value]="defaultItem"
          formControlName="company"
          textField="name"
          valueField="id">
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <span [ngClass]="{'custom-item': true}">{{ dataItem.name }}</span>
          </ng-template>
        </kendo-dropdownlist>
      </kendo-formfield>
    </form>
  }
</ng-container>
